const CEIL = 4;
const DAY_WIDTH = 12 * CEIL;
const GRID_GAP = 1 * CEIL;
const GRID_PADDING = 2 * CEIL;
const MONTHS_GAP = 6 * CEIL;

const getMonthWidth = () => 7 * DAY_WIDTH + 6 * GRID_GAP + 2 * GRID_PADDING;

const getCalendarWidth = (numberOfMonths: number) =>
  numberOfMonths * getMonthWidth() + (numberOfMonths - 1) * MONTHS_GAP;

export default getCalendarWidth;
